export default __webpack_public_path__ + "static/media/androidBg.c1402d74.webp";